module.exports = __webpack_public_path__ + "img/New.2f7aa014.png";